// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

enum TaskStatus {
  IDLE = 'IDLE',
  RUNNING = 'RUNNING',
  CANCELED = 'CANCELED',
  FINISHED = 'FINISHED',
}

export default TaskStatus;
